"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcModalBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var helpers_2 = require("../../../common/helpers");
var bc_modal_constants_1 = require("./bc-modal-constants");
var bc_modal_constants_2 = require("./bc-modal-constants");
var bc_modal_constants_3 = require("./bc-modal-constants");
var bc_modal_constants_4 = require("./bc-modal-constants");
var bc_modal_constants_5 = require("./bc-modal-constants");
var bc_modal_constants_6 = require("./bc-modal-constants");
var bc_modal_constants_7 = require("./bc-modal-constants");
var BcModalBehavior = (function (_super) {
    __extends(BcModalBehavior, _super);
    function BcModalBehavior() {
        var _this = _super.call(this) || this;
        _this.isMainButtonConfigured = false;
        _this.isSecondaryButtonConfigured = false;
        _this.eventClosedAdded = false;
        _this.modalState = bc_modal_constants_5.CLOSE_STATE_MODAL;
        return _this;
    }
    BcModalBehavior.setUpAll = function () {
        var modalElements = Array.from(document.querySelectorAll("article[class='".concat(bc_modal_constants_6.MODAL, "']")));
        var elements = [];
        for (var _i = 0, modalElements_1 = modalElements; _i < modalElements_1.length; _i++) {
            var modal = modalElements_1[_i];
            var bcModalBehavior = new BcModalBehavior();
            bcModalBehavior.setElement(modal);
            bcModalBehavior.setUp();
            elements.push(bcModalBehavior);
        }
        return elements;
    };
    BcModalBehavior.prototype._setUp = function () {
        this.getElement();
        this.configEventListener();
        if (this.closeButton && !this.eventClosedAdded) {
            this.closeButton.removeEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, this.closeModal.bind(this));
            this.closeButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, this.closeModal.bind(this));
            this.eventClosedAdded = true;
        }
        this.accessibility();
        this.optionalClose();
        this.closeEventKey();
        if (this.closeButton !== null) {
            this.setEventToCloseBtn();
        }
    };
    BcModalBehavior.prototype.createOverlay = function () {
        var status = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_modal_constants_1.BC_MODAL_OVERLAY],
        });
        document.body.insertBefore(status, null);
    };
    BcModalBehavior.prototype.accessibility = function () {
        var _this = this;
        var title = this.mySelf.querySelector(".".concat(bc_modal_constants_6.BC_MODAL_TITLE_LABEL));
        var content = this.mySelf.querySelector("section.".concat(bc_modal_constants_1.BC_MODAL_CONTENT));
        (0, helpers_2.addFocusable)(title, { tabindex: '0' });
        (0, helpers_2.addFocusable)(content, { tabindex: '0' });
        (0, helpers_2.addFocusable)(this.closeButton, { pressed: 'false', tabindex: '0' }, { event: function () { return _this.closeModal(); } });
        (0, helpers_2.addFocusable)(this.mainButton, { pressed: 'false' }, { event: function () { return _this.configEventListener(); } });
        (0, helpers_2.addFocusable)(this.secondaryButton, { pressed: 'false' }, { event: function () { return _this.configEventListener(); } });
    };
    BcModalBehavior.prototype.getElement = function () {
        this.mainButton = this.mySelf.querySelector(".".concat(bc_modal_constants_3.BC_MODAL_BUTTON_CONTAINER, " .").concat(common_constants_1.BcCommonConstants.BTN_PRIMARY_CLASS));
        this.secondaryButton = this.mySelf.querySelector(".".concat(bc_modal_constants_3.BC_MODAL_BUTTON_CONTAINER, " .").concat(common_constants_1.BcCommonConstants.BTN_SECONDARY_CLASS));
        this.closeButton = this.mySelf.querySelector("button[class*='".concat(bc_modal_constants_1.BC_MODAL_CLOSE, "']"));
        this.modalOverlay = this.mySelf.querySelector("article[class='".concat(bc_modal_constants_6.MODAL, "']"));
    };
    BcModalBehavior.prototype.configEventListener = function () {
        if (this.callback) {
            if (this.mainButton && !this.isMainButtonConfigured) {
                this.isMainButtonConfigured = true;
                this.configureCallBack(this.mainButton, bc_modal_constants_6.MAIN_TASK);
            }
            if (this.secondaryButton && !this.isSecondaryButtonConfigured) {
                this.configureCallBack(this.secondaryButton, bc_modal_constants_7.SECONDARY_TASK);
                this.isSecondaryButtonConfigured = true;
            }
        }
    };
    BcModalBehavior.prototype.configureCallBack = function (button, state) {
        function functToEval() {
            this.callback(state);
        }
        button.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, functToEval.bind(this), true);
    };
    BcModalBehavior.prototype.optionalClose = function () {
        var _this = this;
        this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            if (event.target.classList.contains(bc_modal_constants_2.MODAL_ACTIVE) &&
                _this.modalState === 1) {
                _this.closeModal();
            }
        });
    };
    BcModalBehavior.prototype.closeEventKey = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                _this.closeModal();
            }
        });
    };
    BcModalBehavior.prototype.openModal = function () {
        this.modalState = bc_modal_constants_4.OPEN_STATE_MODAL;
        this.changeState();
        this.createOverlay();
    };
    BcModalBehavior.prototype.closeModal = function () {
        this.modalState = bc_modal_constants_5.CLOSE_STATE_MODAL;
        this.changeState();
        var overlayElement = document.querySelector(".".concat(bc_modal_constants_1.BC_MODAL_OVERLAY));
        if (overlayElement) {
            overlayElement.remove();
        }
        if (this.closeModalCallback) {
            this.closeModalCallback();
        }
    };
    BcModalBehavior.prototype.changeState = function () {
        if (this.modalState === bc_modal_constants_4.OPEN_STATE_MODAL) {
            this.mySelf.classList.replace(bc_modal_constants_6.MODAL, bc_modal_constants_2.MODAL_ACTIVE);
        }
        else if (this.modalState === bc_modal_constants_5.CLOSE_STATE_MODAL) {
            this.mySelf.classList.replace(bc_modal_constants_2.MODAL_ACTIVE, bc_modal_constants_6.MODAL);
        }
    };
    BcModalBehavior.prototype.setEventToCloseBtn = function () {
        var _this = this;
        this.closeButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.closeModal();
        });
    };
    return BcModalBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcModalBehavior = BcModalBehavior;
